import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { addUser } from "../../js/api/user-access";

const AddNewUser = ({
  roleCardData,
  userData,
  setUserData,
  addUserErrors,
  setAddUserErrors,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    console.log("roleCardData", roleCardData);
  }, [roleCardData]);

  return (
    <div className="space-y-6 p-4 h-[calc(100vh_-_320px)] overflow-y-auto pr-2">
      {/* First Name */}
      <div>
        <label className="block form_label_color pb-2">
          First Name<span className="text-red-500">*</span>
        </label>
        <input
          name="firstName"
          type="text"
          value={userData.firstName}
          onChange={handleChange}
          className="border border_color text-base rounded-lg block w-full p-2.5 h-12"
        />
        {addUserErrors.firstName && (
    <p className="text-red-500 text-sm mt-1">{addUserErrors.firstName}</p>
  )}
      </div>

      {/* Last Name */}
      <div>
        <label className="block form_label_color pb-2">
          Last Name<span className="text-red-500">*</span>
        </label>
        <input
          name="lastName"
          type="text"
          value={userData.lastName}
          onChange={handleChange}
          className="border border_color text-base rounded-lg block w-full p-2.5 h-12"
        />
        {addUserErrors.lastName && (
    <p className="text-red-500 text-sm mt-1">{addUserErrors.lastName}</p>
  )}
      </div>

      {/* Email */}
      <div>
        <label className="block form_label_color pb-2">
          Email<span className="text-red-500">*</span>
        </label>
        <input
          name="email"
          type="email"
          value={userData.email}
          onChange={handleChange}
          className="border border_color text-base rounded-lg block w-full p-2.5 h-12"
        />
        {addUserErrors.email && (
    <p className="text-red-500 text-sm mt-1">{addUserErrors.email}</p>
  )}
      </div>

      {/* Role Dropdown */}
      <div>
        <label className="block form_label_color pb-2">
          Role<span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <select
            name="roleName"
            value={userData.roleName}
            onChange={handleChange}
            className="border border_color text-base rounded-lg block w-full p-2.5 appearance-none"
          >
            <option value="">Select Role</option>
            {roleCardData &&
              roleCardData.length > 0 &&
              roleCardData.map((val, key) => (
                <option value={val.roleName} key={key}>
                  {val.roleName}
                </option>
              ))}
          </select>

          {/* <FaChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-purple-500 text-xs" /> */}

          <svg
            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
              stroke="#245CEA"
              strokeWidth="2"
              stroke-miterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {addUserErrors.roleName && (
    <p className="text-red-500 text-sm mt-1">{addUserErrors.roleName}</p>
  )}
        </div>
      </div>
    </div>
  );
};

export default AddNewUser;
